import { Autocomplete, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useEffect, useState } from 'react';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { FaFileExcel, FaRegEye } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import { fetchAreasOrganizacionales, selectAllAreasOrganizacionales } from '../../redux/AreaOrganizacional/AreaOrganizacionalSlice';

import { fetchGruposOcupacionalesLista, selectAllGruposOcupacionales } from '../../redux/GruposOcupacionales/GruposOcupacionalesSlice';

import { fetchCargosAll, selectAllCargos } from '../../redux/Cargos/CargosSlice';

import { camposReporteEmpleados } from '../../utils/camposReporteEmpleados';
import { estadosEmpleado } from '../../utils/estadosEmpleado';

import {
  fetchGetReporteDinamico,
  fetchGetReporteDinamicoCount,
  fetchGetReportePorAreas,
  fetchGetReportePorAreasPrincipales,
  fetchReporteDinamicoExcel,
} from '../../redux/Empleados/EmpleadosSlice';

import { fetchUbicaciones, selectUbicaciones } from '../../redux/Utility/UtilitySlice';

export const FiltroReporteEmpleado = ({ setCampos, setPage, page, rowsPerPage, setSkipRow, reporteCount, skipRow }) => {
  // ? HOOK-FORM
  const {
    register,
    formState: { errors },
    control,
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      filtro: {
        areaId: [],
        grupoOcupacionalId: [],
        cargoId: [],
        ubicacionId: [],
        estado: 1,
      },
      campos: {
        nombres: true,
        codigoEmpleado: true,
        cedula: true,
        sexo: true,
        areaOrganizacional: false,
        ubicacion: false,
        estudios: false,
        cargo: false,
        supervisor: false,
        cuentaBancaria: false,
        sueldo: false,
        fechaIngreso: false,
        edad: false,
        grupoOcupacional: false,
        correoInstitucional: false,
        fechaNacimiento: false,
        celular: false,
        flota: false,
        foto: false,
        fechaTerminoDestitucion: false,
        motivoDestitucion: false,
        asignaciones: false,
      },
    },
  });

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-SELECTOR
  const listAreaOrganizacionales = useSelector(selectAllAreasOrganizacionales);
  const listGruposOcupacionales = useSelector(selectAllGruposOcupacionales);
  const listCargos = useSelector(selectAllCargos);
  const listUbicaciones = useSelector(selectUbicaciones);

  // ? HOOK-STATE DE LISTAS
  const [listaCamposState, setListaCamposState] = useState([]);

  // ? HOOK-STATE PARA VALIDACIONES
  const [validacionSeleccionCampos, setValidacionSeleccionCampos] = useState(false);
  const [camposInactivoHabilitado, setCamposInactivoHabilitado] = useState(false);

  // ? HOOK-WATCH
  const camposObjecto = useWatch({
    control,
    name: 'campos',
  });

  // ? VARIABLE QUE ALMACENA EL ESTADO
  const estado = useWatch({
    control,
    name: 'filtro.estado',
  });

  useEffect(() => {
    dispatch(fetchAreasOrganizacionales());
    dispatch(fetchGruposOcupacionalesLista());
    dispatch(fetchCargosAll());
    dispatch(fetchUbicaciones());
  }, []);

  useEffect(() => {
    // * DIVISION DE COLUMNAS DEL ARRAY.
    let arr = [];
    let cont = 5;
    for (let index = 0; index < 5; index++) {
      arr = [...arr, camposReporteEmpleados.slice(index === 0 ? index : index * 5, cont)];
      cont += 5;
    }

    setListaCamposState(arr);
  }, []);

  useEffect(() => {
    // * VALIDACION DE QUE EXISTA UN CAMPO SELECCIONADO O CON VALOR TRUE.
    const isEmptyObject = Object.keys(camposObjecto).some((x) => camposObjecto[x] === true);
    setValidacionSeleccionCampos(isEmptyObject);

    setCampos(camposObjecto);
  }, [camposObjecto]);

  useEffect(() => {
    setCamposInactivoHabilitado(estado === 1 ? true : false);
  }, [estado, camposInactivoHabilitado]);

  useEffect(() => {
    if (reporteCount > 0) {
      vistaPrevia();
    }
  }, [page, rowsPerPage, skipRow]);

  useEffect(() => {
    if (camposInactivoHabilitado) {
      const campos = watch('campos');
      campos.motivoDestitucion = false;
      campos.fechaTerminoDestitucion = false;

      setValue('campos', campos);
    }
  }, [camposInactivoHabilitado]);

  // * FUNCION PARA SOLICITAR LA VISTA PREVIA
  const vistaPrevia = () => {
    // * FILTRO
    const filtro = watch('filtro');

    dispatch(fetchGetReporteDinamico({ filtro, skipRow, rowsPerPage }));
    dispatch(fetchGetReporteDinamicoCount({ filtro }));
  };

  const generarExcel = () => {
    const data = {
      campos: watch('campos'),
      filtros: watch('filtro'),
    };

    dispatch(fetchReporteDinamicoExcel(data));
  };

  return (
    <>
      <Paper elevation={3}>
        <Grid container p={2}>
          <Grid item xs={6}>
            <Stack p={1}>
              <Typography variant="h6">FILTROS</Typography>
              <Divider />

              <Stack p={1} mt={2}>
                <Stack mt={1}>
                  <Typography fontSize="14px" fontWeight="bold">
                    Ubicaciones
                  </Typography>
                  <Controller
                    control={control}
                    name="filtro.ubicacionId"
                    render={({ field: { value, onChange } }) => (
                      <Autocomplete
                        value={listUbicaciones.filter((x) => value.some((v) => x.id === v))}
                        multiple
                        id="tags-outlined"
                        options={listUbicaciones}
                        getOptionLabel={(option) => option.descripcion}
                        filterSelectedOptions
                        onChange={(event, newValue) => {
                          onChange(newValue.map((x) => x.id));
                        }}
                        isOptionEqualToValue={(option, val) => option.id === val.id} // clave para evitar duplicados
                        renderInput={(params) => <TextField {...params} key={params.id} label=" " placeholder="Seleccionar Ubicación" />}
                        className="mb-2"
                      />
                    )}
                  />
                </Stack>

                <Stack>
                  <Typography fontSize="14px" fontWeight="bold">
                    Área Organizacional
                  </Typography>

                  <Controller
                    control={control}
                    name="filtro.areaId"
                    render={({ field: { value, onChange } }) => (
                      <Autocomplete
                        value={listAreaOrganizacionales.filter((x) => value.some((v) => x.id === v))}
                        multiple
                        id="tags-outlined"
                        options={listAreaOrganizacionales}
                        getOptionLabel={(option) => option.nombre}
                        filterSelectedOptions
                        onChange={(event, newValue) => {
                          onChange(newValue.map((x) => x.id));
                        }}
                        isOptionEqualToValue={(option, val) => option.id === val.id} // clave para evitar duplicados
                        renderInput={(params) => <TextField {...params} key={params.id} label=" " placeholder="Seleccionar Área" />}
                        className="mb-2"
                      />
                    )}
                  />
                </Stack>

                <Stack mt={1}>
                  <Typography fontSize="14px" fontWeight="bold">
                    Grupo Ocupacional
                  </Typography>
                  <Controller
                    control={control}
                    name="filtro.grupoOcupacionalId"
                    render={({ field: { value, onChange } }) => (
                      <Autocomplete
                        value={listGruposOcupacionales.filter((x) => value.some((v) => x.id === v))}
                        multiple
                        id="tags-outlined"
                        options={listGruposOcupacionales}
                        getOptionLabel={(option) => option.nombre}
                        filterSelectedOptions
                        onChange={(event, newValue) => {
                          onChange(newValue.map((x) => x.id));
                        }}
                        isOptionEqualToValue={(option, val) => option.id === val.id} // clave para evitar duplicados
                        renderInput={(params) => <TextField {...params} key={params.id} label=" " placeholder="Seleccionar Grupo" />}
                        className="mb-2"
                      />
                    )}
                  />
                </Stack>

                <Stack mt={1}>
                  <Typography fontSize="14px" fontWeight="bold">
                    Cargos
                  </Typography>
                  <Controller
                    control={control}
                    name="filtro.cargoId"
                    render={({ field: { value, onChange } }) => (
                      <Autocomplete
                        value={listCargos.filter((x) => value.some((v) => x.id === v))}
                        multiple
                        id="tags-outlined"
                        options={listCargos}
                        getOptionLabel={(option) => option.titulo}
                        filterSelectedOptions
                        onChange={(event, newValue) => {
                          onChange(newValue.map((x) => x.id));
                        }}
                        isOptionEqualToValue={(option, val) => option.id === val.id} // clave para evitar duplicados
                        renderInput={(params) => <TextField {...params} key={params.id} label=" " placeholder="Seleccionar Cargo" />}
                        className="mb-2"
                      />
                    )}
                  />
                </Stack>

                <Stack mt={1}>
                  <Typography fontSize="14px" fontWeight="bold">
                    Estado
                  </Typography>
                  <Controller
                    control={control}
                    name="filtro.estado"
                    {...register('filtro.estado')}
                    render={({ field }) => (
                      <Select
                        classNamePrefix="select"
                        isSearchable={true}
                        placeholder="Seleccionar Estado"
                        options={estadosEmpleado}
                        getOptionLabel={(option) => option.nombre}
                        getOptionValue={(option) => option.id}
                        onChange={(e) => field.onChange(e.id)}
                        defaultValue={estadosEmpleado.filter((x) => x.id === field.value)}
                      />
                    )}
                  />
                </Stack>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={6}>
            <Stack p={1}>
              <Typography variant="h6">CAMPOS</Typography>
              <Divider />

              <Grid mt={2}>
                <Paper>
                  <Stack p={2} height={'270px'}>
                    <Grid container spacing={{ lg: 2, md: 1 }}>
                      {listaCamposState.length > 0 &&
                        listaCamposState.map((item, index) => (
                          <Grid item key={index} xs={3}>
                            {item.map((item2) => (
                              <>
                                {item2.campo === 'fechaTerminoDestitucion' && (
                                  <Typography hidden={camposInactivoHabilitado} fontWeight="bold" fontSize="14px">
                                    Destitución
                                  </Typography>
                                )}

                                <Stack>
                                  <FormControlLabel
                                    hidden={
                                      (item2.campo === 'fechaTerminoDestitucion' || item2.campo === 'motivoDestitucion') && camposInactivoHabilitado
                                        ? true
                                        : false
                                    }
                                    key={item2.campo}
                                    sx={{
                                      '& .MuiTypography-root': {
                                        fontSize: { lg: 12, md: 10, xs: 11 },
                                      },
                                    }}
                                    control={
                                      <Checkbox checked={getValues('campos')[item2.campo] === true} {...register(`campos.${item2.campo}`, {})} />
                                    }
                                    label={item2?.label}
                                  />
                                </Stack>
                              </>
                            ))}
                          </Grid>
                        ))}

                      <p style={{ marginLeft: 10, marginBottom: -2 }} className="text-danger">
                        {!validacionSeleccionCampos && 'Debe seleccionar al menos un campo'}
                      </p>
                    </Grid>
                  </Stack>
                </Paper>
              </Grid>
            </Stack>
          </Grid>

          <Grid item xs={12} className="d-flex mt-2 justify-content-between">
            <div className="justify-content-start">
              <button onClick={() => dispatch(fetchGetReportePorAreas())} className="btn me-2 btn-orange" disabled={!validacionSeleccionCampos}>
                Reporte por Áreas <FaFileExcel fontSize={22} style={{ marginTop: -3 }} />
              </button>
              <button onClick={() => dispatch(fetchGetReportePorAreasPrincipales())} className="btn btn-green" disabled={!validacionSeleccionCampos}>
                Reporte de Áreas Principales <FaFileExcel fontSize={22} style={{ marginTop: -3 }} />
              </button>
            </div>
            <div className="justify-content-end">
              <button
                onClick={() => {
                  // * RESETEAR PAGINACION.
                  setPage(0);
                  setSkipRow(0);
                  vistaPrevia();
                }}
                className="btn btn-primary-mem me-2"
                disabled={!validacionSeleccionCampos}
              >
                Vista previa
                <FaRegEye fontSize={22} style={{ marginTop: -2, marginLeft: 3 }} />
              </button>
              <button onClick={() => generarExcel()} className="btn btn-success" disabled={!validacionSeleccionCampos}>
                Generar Excel <FaFileExcel fontSize={22} style={{ marginTop: -3 }} />
              </button>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};
